/**
 * Created by Steven-DESK on 10/06/2017.
 */
$(document).ready(function () {
    calcHeight()
});
$(window).resize(function () {
    calcHeight()
});
function calcHeight() {
    $(".main_bg").height($("footer").position().top - $(".main_bg").position().top - 10)
}


//////////////////
// WEBPACK FOOTER
// ./js/footer.js
// module id = 16
// module chunks = 0